import React from "react";
import styled, { keyframes } from "styled-components";
import ShimmerPlaceholder from "./placeholders/ShimmerPlaceholder";

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const FallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10rem;
  min-height: 100vh;
  background-color: #f8f9fa;
  gap: 2rem;
`;

const Spinner = styled.div`
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${rotate} 1s linear infinite;
  margin-bottom: 1rem;
`;

const FallbackText = styled.div`
  font-size: 20px;
  color: #6c757d;
  margin-top: 1rem;
`;

const FallbackLoader = () => {
  const showShimmer = true;

  return (
    <FallbackContainer>
      {/* <Spinner /> */}
      <ShimmerPlaceholder visible={showShimmer} height="4em" width="80%" />
      <ShimmerPlaceholder visible={showShimmer} height="4em" width="80%" />
      <ShimmerPlaceholder visible={showShimmer} height="4em" width="80%" />
      <ShimmerPlaceholder visible={showShimmer} height="4em" width="80%" />
      <FallbackText>Loading, please wait...</FallbackText>
    </FallbackContainer>
  );
};

export default FallbackLoader;
